import { trackEvent } from './analytics'

/**
 * Click Tracking - fires a `uxp_widget_click` analytics event for any clickable
 * widget element (links, buttons, images, cards, icons, etc). Tab clicks are
 * tracked separately via useTabTracking (`uxp_widget_tab_click`) — do not use
 * this for tab onChange handlers.
 *
 * trackWidgetClick(
 *   dispatch,
 *   'CampusPass',                 // actionContext: widget name
 *   'Renew My Campus Pass',       // actionContextValue: label/description of the clicked item
 *   { widgetId },                 // options
 * )
 */
export const trackWidgetClick = (
  dispatch,
  actionContext,
  actionContextValue,
  options = {},
) => {
  trackEvent(dispatch, {
    eventName: 'uxp_widget_click',
    module: 'Dashboard',
    object: 'Widget',
    action: 'Click',
    actionContext,
    actionContextValue,
    ...options,
  })
}

export default trackWidgetClick
